import React, { useRef, useState } from 'react';
import ProTable from '@ant-design/pro-table';
import { Button, Modal, Spin, message } from 'antd';
import { getOrderList, getOrderAnalysisResult } from '@/services/order';
import { guuid } from '@/utils/utils';
import { history } from 'umi';
const OrderRecordView = (props) => {
  // eslint-disable-next-line react/prop-types
  const { userId, userPhone } = props;
  /// 订单记录
  const orderTableRef = useRef();
  
  // 弹窗状态管理
  const [modalVisible, setModalVisible] = useState(false);
  const [analysisData, setAnalysisData] = useState(null);
  const [loading, setLoading] = useState(false);

  const goRecord = (record) => {
    history.push(`/operating/order?orderNo=${record.orderNo}`);
  };

  // 处理订单分析
  const handleOrderAnalysis = async (orderNo) => {
    setLoading(true);
    setModalVisible(true);
    try {
      const { data, code } = await getOrderAnalysisResult({
        requestData:orderNo
      });
      if (code === '00000') {
        setAnalysisData(data);
      } else {
        message.error('获取订单分析结果失败');
        setModalVisible(false);
      }
    } catch (error) {
      message.error('获取订单分析结果失败');
      setModalVisible(false);
    } finally {
      setLoading(false);
    }
  };

  const orderTableColumns = [
    {
      title: '创建时间',
      valueType: 'dateTimeRange',
      dataIndex: 'createTime',
      render: (val) => {
        return val.props.text;
      },
    },
    {
      title: '订单商品',
      dataIndex: 'goodsName',
      render: (text, record, index, action) => {
        return (
          <a
            onClick={() => {
              goRecord(record);
            }}
            style={{ textDecoration: 'underline', color: '#333' }}
          >
            {text}
          </a>
        );
      },
    },

    {
      title: '实付金额',
      dataIndex: 'paidAmount',
      hideInSearch: true,
    },
    {
      title: '创建方式',
      dataIndex: 'promotionTypeName',
    },
    {
      title: '订单状态',
      dataIndex: 'orderStatusName',
    },
    {
      title: '来源渠道',
      dataIndex: 'orderChannelName',
      hideInSearch: true,
    },
    {
      title: '成单分析',
      dataIndex: 'action',
      hideInSearch: true,
      width: 150,
      render: (text, record) => {
        // 只有订单状态为3时才显示分析结论按钮
        if (record.orderStatus === 3) {
          return (
            <Button 
              type="primary" 
              size="small"
              onClick={() => handleOrderAnalysis(record.orderNo)}
            >
              查看分析结论
            </Button>
          );
        }
        return null;
      },
    },
  ];
  // const { formData, extraButton, onSearch, onReset, loading } = props;
  return (
    <>
      <ProTable
        columns={orderTableColumns}
        actionRef={orderTableRef}
        request={async (params) => {
          const { data, page, code } = await getOrderList({
            requestData: {
              ...params,
              userId: userId,
            },
            page: {
              currentPage: params.current,
              pageSize: params.pageSize,
            },
          });
          if (code !== '00000') {
            return {
              success: false,
            };
          }
          return {
            data: data,
            success: true,
            total: page.count,
          };
        }}
        columnsState={{
          persistenceKey: 'pro-table-singe-demos2',
          persistenceType: 'localStorage',
        }}
        rowKey={() => guuid()}
        search={false}
        scroll={{ x: 'max-content' }}
        pagination={{
          defaultPageSize: 10,
        }}
        dateFormatter="string"
        toolBarRender={false}
      />
      
      {/* 成单分析弹窗 */}
      <Modal
        title="成单分析"
        open={modalVisible}
        onCancel={() => {
          setModalVisible(false);
          setAnalysisData(null);
        }}
        footer={[
          <Button key="close" onClick={() => {
            setModalVisible(false);
            setAnalysisData(null);
          }}>
            关闭
          </Button>
        ]}
        width={600}
      >
        <Spin spinning={loading}>
          {analysisData && (
            <div style={{ padding: '16px 0' }}>
              <div style={{ marginBottom: '24px' }}>
                <h3 style={{ 
                  marginBottom: '12px', 
                  color: '#1890ff', 
                  fontSize: '16px',
                  fontWeight: 'bold',
                  borderLeft: '4px solid #1890ff',
                  paddingLeft: '12px',
                  background: 'linear-gradient(90deg, #f0f8ff 0%, transparent 100%)',
                  padding: '8px 12px',
                  borderRadius: '4px'
                }}>
                  🤖 智能体输入
                </h3>
                <div style={{ 
                  padding: '16px', 
                  backgroundColor: '#f5f5f5', 
                  borderRadius: '6px',
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                  border: '1px solid #e8e8e8',
                  fontSize: '14px',
                  lineHeight: '1.6'
                }}>
                  {analysisData.input || '暂无数据'}
                </div>
              </div>
              
              <div>
                <h3 style={{ 
                  marginBottom: '12px', 
                  color: '#52c41a', 
                  fontSize: '16px',
                  fontWeight: 'bold',
                  borderLeft: '4px solid #52c41a',
                  paddingLeft: '12px',
                  background: 'linear-gradient(90deg, #f6ffed 0%, transparent 100%)',
                  padding: '8px 12px',
                  borderRadius: '4px'
                }}>
                  📊 分析结论
                </h3>
                <div style={{ 
                  padding: '16px', 
                  backgroundColor: '#f0f8ff', 
                  borderRadius: '6px',
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                  border: '1px solid #d9f7be',
                  fontSize: '14px',
                  lineHeight: '1.6'
                }}>
                  {analysisData.conclusion || '暂无数据'}
                </div>
              </div>
            </div>
          )}
        </Spin>
      </Modal>
    </>
  );
};

export default OrderRecordView;
